export default __webpack_public_path__ + "static/media/operacoes-executadas.bbed3b3e.svg";